// import { Client } from '@hubspot/api-client'
import axios from 'axios'

// export const hubspotTest = async function(){
  // const hubspotClient = new Client({accessToken: process.env.VUE_APP_SOME_TEST})
  // const publicObjectSearchRequest = {
  //     filterGroups: [
  //       {
  //         filters: [
  //           {
  //             propertyName: 'createdate',
  //             operator: 'GTE',
  //             value: `${Date.now() - 30 * 60000}`
  //           }
  //         ]
  //       }
  //     ],
  //     sorts: [{ propertyName: 'createdate', direction: 'DESCENDING' }],
  //     properties: ['createdate', 'firstname', 'lastname'],
  //     limit: 5,
  //     after: 0,
  // };

  // const response = await hubspotClient.crm.contacts.searchApi.doSearch(publicObjectSearchRequest)
  // const response = await hubspotClient.crm.contacts.basicApi.getPage(5)
  // console.log(response)
  // return response;
// }

// export const axiosTest = async function(){
//   const objectType = 'contacts'
//   const route = `/crm/v3/objects/${objectType}`;

//   let config = {
//     method: 'get',
//     baseURL: 'https://api.hubapi.com',
//     headers: {
//       'Authorization': ('Bearer ' + process.env.VUE_APP_SOME_TEST),
//       'Accept': 'application/json'
//     }
//   };

//   const axiosInstance = new Axios(config);


//   axiosInstance.get(route).then(function (response) {
//     console.log(response.data)
//     let ctype = response.headers["content-type"];
//     console.log(ctype);
//   })
//   .catch(function (error) {
//     console.log(error);
//   });
// }

// export const axiosTest = async function(formData){
//   // console.log(process.env.VUE_APP_SOME_TEST)
//   // console.log(formData)


//   // const response = await axios.get(`http://localhost:8000/api/${testVar}`)

//   const response = await axios.post(`https://3dkmm5xanxnjaiukpjmat7pb3a0lytsi.lambda-url.us-west-2.on.aws`, formData)
//   // const response = await axios.post(`http://localhost:8000/submit`, formData)

  
//   return response.data;
// }

export const axiosFormSubmit = async function(formData){
  const response = await axios.post(`https://3dkmm5xanxnjaiukpjmat7pb3a0lytsi.lambda-url.us-west-2.on.aws`, formData, {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
  }).then((res) => {
    // console.log('RESPONSE:');
    console.log(res);
    // console.log('==========================');
  }).catch((err) => {
    // console.log('ERROR:');
    console.log(err);
    // console.log('==========================');
  });

  console.log(response);

  // return response.data;
  return;
}